module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/area-icon1-991532bb66b63a9d615bca08c4f9d884.svg&quot;;"